// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"226":"d9aaf0a7","809":"292dca10"}[chunkId] + ".css";
};